import React, { Suspense } from 'react';

import { Values as ValuesView } from '@modules/Values/views/Values';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';


export const Values: React.FC = () => {

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%"/>}>
        <ValuesView/>
      </Suspense>
    </ErrorBoundary>
  );
};